/* eslint-env browser, es6 */
import m from "mithril";

import {ApiError} from "../api";
import {KEY_SPACEBAR} from "../constants";
import {GameController} from "../game-controller";
import {GAME, GameStateFinished, initialState} from "../game-state";
import {ApiErrorView} from "./api-error";
import {FinishedBoardView} from "./board";
import {ButtonView} from "./button";
import {CopyPasteView} from "./copy-paste";
import {DuelDialogView} from "./duel-dialog";
import {DuelResultsView} from "./duel-results";
import {FooterView, HeaderView} from "./header-footer";
import {InputView} from "./input";
import {ScoreMessageView} from "./messages";
import {MissedWordsView} from "./missed-words";
import {WordListView} from "./word-list";
import {getPersistentNicknameForDuel} from "../persistent-nickname";

interface GameFinishedViewAttrs {
  state: GameStateFinished;
}

export class GameFinishedView implements m.Component<GameFinishedViewAttrs> {
  private state: GameStateFinished;
  private inDuelDialog: boolean;

  constructor(vnode: m.Vnode<GameFinishedViewAttrs>) {
    this.state = vnode.attrs.state;
    this.inDuelDialog = false;
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === KEY_SPACEBAR) {
      GameController.startGame();

      // Prevent space bar from scrolling page.
      event.preventDefault();
      m.redraw();
    }
  }

  oncreate(): void {
    document.addEventListener("keydown", this.onKeyDown);
  }

  onremove(): void {
    document.removeEventListener("keydown", this.onKeyDown);
  }

  view(): m.Children {
    const nickname = this.state.duel
      ? getPersistentNicknameForDuel(this.state.duel.duelId)
      : "";

    return [
      m(HeaderView),
      this.state.error ? m(ApiErrorView, {error: this.state.error}) : null,
      m(InputView, {disabled: true}),
      m(FinishedBoardView, {board: this.state.board}),
      m(ButtonView, {
        message: "New game",
        hookOnClick: () => {
          GAME.state = initialState();
          m.route.set("/webble");
        },
      }),
      this.inDuelDialog
        ? m(DuelDialogView, {
          hookOnError: (error: ApiError) => {
            this.state.error = error;
          },
          board: this.state.board,
          hideStartButton: true,
        })
        : this.state.duel
          ? null
          : m(ButtonView, {
            message: "Challenge a friend",
            hookOnClick: () => {
              this.inDuelDialog = true;
            },
          }),
      m(ScoreMessageView, {score: this.state.score, maxScore: this.state.maxScore}),
      this.state.duel
        ? [
          m(DuelResultsView, {duel: this.state.duel, nickname}),
          m(CopyPasteView, {duelId: this.state.duel.duelId}),
        ]
        : null,
      m(WordListView, {wordList: this.state.userWordList}),
      m(MissedWordsView, {missedWords: this.state.missedWords}),
      m(FooterView),
    ];
  }
}
